import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@app/default/auth/services/authentication.service';
import { Model } from 'src/app/shared/models/clux/model-legacy';

import { environment } from '../../../../environments/environment';
import { CommonConstants } from '../../constants/common.constant';
import { ClientQuery } from '@app/state';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-net-suite-modal',
  templateUrl: './net-suite-modal.component.html',
  styleUrls: ['./net-suite-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton],
})
export class NetSuiteModalComponent implements OnInit {
  public dialog = inject(MatDialog);
  public data = inject<Model.MatDialogModel>(MAT_DIALOG_DATA);
  private modalRef = inject<MatDialogRef<NetSuiteModalComponent>>(MatDialogRef);
  private authenticationService = inject(AuthenticationService);
  private clientQuery = inject(ClientQuery);

  public externalRouteMessage: string;
  public externalId: string | undefined;

  public ngOnInit(): void {
    this.externalRouteMessage = CommonConstants.errorCodes.externalRouteMessage;
  }

  public async onContinue(): Promise<void> {
    this.modalRef.close();
    const idToken = await this.authenticationService.getValidIdToken();
    if (this.data.cameFrom === 'myAccount') {
      this.externalId = this.clientQuery.getActive()?.externalId;
      if (this.externalId) {
        window.open(`https://${environment.netSuite.myAccountBaseUrl}/scs/checkout.ssp?is=login&email=${this.externalId}&uix=true&login=T#login-register`);
      }
    } else {
      window.open(`https://${environment.netSuite.cluxHost}/${CommonConstants.appRoutes.netSuiteSSORedirect}?ns=${this.data.cameFrom}&t=${idToken}`, this.data.cameFrom);
    }
  }

  public onCancel(): void {
    this.modalRef.close();
  }
}
